import {useDispatch} from 'react-redux';
import {actionCreators} from '../../../store';
import Loader, {ILoaderRef} from '../../../com/loader/Loader';
import completeRegistrationIcon from '../../../assets/auth/mail_icon.svg'

import './CompleteUserRegistration.scss'
import {useRef} from 'react';
import {useEffect} from 'react';
import {ActionType} from '../../../store/actionTypes';
import {useTypedSelector} from '../../../hooks/useTypeSelector';
import {useState} from 'react';
import {logout} from "../../../store/actionCreators";
import {resetFlyerState} from "../../../store/actionCreators/flippingFlyerActionCreators";
import {clearFlyersData} from "../../../store/actionCreators/flyersActionCreators";

interface ICompleteRegistration {
    userId: number,
    userEmail: string,
    userToken: string,
    onRegisterEmailSucceeded: () => void
    onRegisterEmailFailed: () => void
}

export const CompleteUserRegistration: React.FC<ICompleteRegistration> = ({
                                                                          userId,
                                                                          userEmail,
                                                                          userToken,
                                                                          onRegisterEmailSucceeded,
                                                                          onRegisterEmailFailed
                                                                      }) => {

    const dispatch = useDispatch();

    const loader = useRef<ILoaderRef>(null);
    const {type} = useTypedSelector((state) => state.auth);

    const [status, setStatus] = useState('In Progress')
    const [statusClass, setStatusClass] = useState('')

    const onRegistraterClick = () => {
        loader.current?.showLoader(true)
        dispatch(actionCreators.confirmEmail(userId, userToken, false));
    }

    const delay = 1000;

    useEffect(() => {
        if (type === ActionType.CONFIRM_EMAIL_COMPLETED) {
            setTimeout(() => {
                loader.current?.showLoader(false)

                setStatus('Succeded')
                setStatusClass('success')

                setTimeout(() => {
                    onRegisterEmailSucceeded()
                }, delay);
            }, delay);
        }
        if (type === ActionType.CONFIRM_EMAIL_ERROR) {
            setTimeout(() => {
                loader.current?.showLoader(false)
                onRegisterEmailFailed()

                setStatus('Failed')
                setStatusClass('failed')
            }, delay);
        }
    }, [type])

    useEffect(() => {
        dispatch(logout());
        dispatch(resetFlyerState());
        dispatch(clearFlyersData());
        setTimeout(() => {
            onRegistraterClick();
        }, 1000)
    }, [])

    return (

        <div className="auth_item_container complete_registration_container">

            <img src={completeRegistrationIcon} alt=""/>

            <p>Hello {userEmail},</p>

            <p>Registration <span className={statusClass}>{status}</span></p>

            <Loader ref={loader}/>

            <p style={status === 'Failed' ? {display: 'initial'} : {display: 'none'}}>Please contact the
                Administrator</p>

            <p className="bottom_paragraph">xCircular Team</p>

        </div>


    )
}